import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, inject, OnInit } from '@angular/core';
import { gameManager } from 'src/app/game/businesslogic/GameManager';
import { settingsManager } from 'src/app/game/businesslogic/SettingsManager';
import { MonsterType } from 'src/app/game/model/data/MonsterType';
import { Monster } from 'src/app/game/model/Monster';
import { MonsterStatsComponent } from 'src/app/ui/figures/monster/stats/stats';

@Component({
  imports: [NgClass, forwardRef(() => MonsterStatsComponent)],
  selector: 'ghs-stat-dialog',
  templateUrl: './stat-dialog.html',
  styleUrls: ['./stat-dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MonsterStatDialogComponent implements OnInit {
  private dialogRef = inject(DialogRef);

  opened: boolean = false;
  monster: Monster;
  forceStats: boolean;

  data: { monster: Monster; forceStats: boolean } = inject(DIALOG_DATA);

  constructor() {
    this.monster = this.data.monster;
    this.forceStats = this.data.forceStats;
  }

  ngOnInit(): void {
    this.opened = true;
  }

  close() {
    this.opened = false;
    setTimeout(
      () => {
        this.dialogRef.close();
      },
      settingsManager.settings.animations ? 1000 * settingsManager.settings.animationSpeed : 0
    );
  }

  getBackside(): Monster {
    const monster: Monster = new Monster(this.monster);
    if (monster.boss) {
      gameManager.monsterManager.addMonsterEntity(monster, 1, MonsterType.boss);
    } else {
      gameManager.monsterManager.addMonsterEntity(monster, 1, MonsterType.normal);
      gameManager.monsterManager.addMonsterEntity(monster, 1, MonsterType.elite);
    }
    monster.isAlly = this.monster.isAlly;
    monster.isAllied = this.monster.isAllied;
    monster.level = this.monster.level < 4 ? this.monster.level + 4 : this.monster.level - 4;
    monster.errors = this.monster.errors;
    return monster;
  }
}
